/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Component that displays a button at the top of a record.
const RecordButton = ({ onClick, label, disabled }) => (
  <div className={`btn btn-primary align-self-center mr-1${disabled ? ' disabled' : ''}`} onClick={onClick}>
    {label}
  </div>
);

RecordButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RecordButton;
